module.exports = __webpack_public_path__ + "img/robomarket-mascot.58f2705f.png";